import React, { ReactElement } from 'react';

interface Props {
  width?: number | string;
  height?: number | string;
  style?: React.CSSProperties;
}

const OpenFolder = (props: Props): ReactElement => {
  const { width, height, style } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      style={style}
      viewBox="0 0 24 24"
    >
      <g fill="currentColor" fillRule="nonzero">
        <path
          d="M4.873 19C3.84 19 3 18.117 3 17.028V6.972C3 5.882 3.839 5 4.873 5h5.245c.839 0 1.549.58 1.788 1.38h5.705c.982 0 1.788.797 1.867 1.81.867.172 1.522.974 1.522 1.937 0 .12-.01.238-.03.356l-1.204 6.901c-.163.936-.938 1.616-1.843 1.616H4.873zm1.579-9.662c-.354 0-.658.26-.733.622l-.004.024-1.204 6.902c-.008.047-.012.094-.012.142 0 .428.323.776.726.789h12.698c.354 0 .658-.26.733-.622l.004-.024 1.204-6.902c.008-.047.012-.094.012-.142 0-.312-.172-.581-.42-.71l-.016-.007-.028-.013-.011-.005-.029-.01-.036-.013-.03-.008-.024-.006-.022-.005-.026-.004-.033-.004-.016-.002-.035-.002H6.452zm3.666-3.155H4.873c-.406 0-.736.34-.749.764v5.607l.485-2.783c.164-.936.939-1.616 1.843-1.616h11.885c-.082-.333-.364-.58-.703-.591h-6.553l-.248-.83c-.094-.316-.37-.54-.69-.55h-.025z"
          transform="translate(-72 -146) translate(72 146)"
        />
      </g>
    </svg>
  );
};

OpenFolder.defaultProps = {
  width: '24px',
  height: '24px',
  style: {},
};

export default OpenFolder;
